import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router';
import { isMobileOnly } from 'react-device-detect';
import { HeartOutlined, BookOutlined, CheckCircleOutlined, BarChartOutlined } from '@ant-design/icons';

const Wrap = styled.div`
  display: grid;
  grid-template-columns: repeat(${(props) => props.$count || 4}, minmax(0, 1fr));
  gap: 10px;
  width: 100%;
  background: #ffffff;
  border-radius: 20px;
  padding: 10px;
  border: 1.5px solid rgba(8, 145, 178, 0.12);
  box-shadow: 0 2px 12px rgba(8, 145, 178, 0.12);
  box-sizing: border-box;
  @media (max-width: 768px) {
    gap: 8px;
    padding: 8px;
  }
`;

const MenuButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ $isMobile }) => ($isMobile ? '6px' : '8px')};
  min-height: ${({ $isMobile }) => ($isMobile ? '40px' : '46px')};
  padding: ${({ $isMobile }) => ($isMobile ? '8px 10px' : '12px 16px')};
  border-radius: 14px;
  border: 1.5px solid transparent;
  background: ${(props) => (props.$active ? 'linear-gradient(135deg,#0891b2,#06b6d4)' : 'transparent')};
  color: ${(props) => (props.$active ? '#ffffff' : '#4a6380')};
  font-size: ${({ $isMobile }) => ($isMobile ? '12px' : '14px')};
  font-weight: 800;
  cursor: pointer;
  font-family: 'Nunito', sans-serif;
  transition: all 0.18s ease;
  &:hover {
    border-color: ${(props) => (props.$active ? 'transparent' : 'rgba(8, 145, 178, 0.18)')};
    background: ${(props) => (props.$active ? 'linear-gradient(135deg,#0891b2,#06b6d4)' : 'rgba(8, 145, 178, 0.06)')};
  }
`;

const IconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ $isMobile }) => ($isMobile ? '14px' : '16px')};
  line-height: 1;
`;

export default function LevelUpLibraryMenuGroup3({ currentMenu, student_idx = null }) {
  const history = useHistory();
  const isMobile = window.isNativeAppMobile || isMobileOnly;

  const items = [
    !student_idx && {
      key: 'favorite',
      icon: <HeartOutlined />,
      label: 'Favorite',
      path: '/level-up/favorite',
    },
    !student_idx && {
      key: 'in_progress',
      icon: <BookOutlined />,
      label: 'In Progress',
      path: '/level-up/inprogress',
    },
    {
      key: 'portfolio',
      icon: <CheckCircleOutlined />,
      label: 'Portfolio',
      path: `/level-up/portfolio${student_idx ? `?student_idx=${student_idx}` : ''}`,
    },
    {
      key: 'calendar',
      icon: <BarChartOutlined />,
      label: isMobile ? 'Calendar' : 'Pts & Calendar',
      path: `/level-up/calendar${student_idx ? `?student_idx=${student_idx}` : ''}`,
    },
  ].filter(Boolean);

  return (
    <Wrap $count={items.length}>
      {items.map((item) => (
        <MenuButton key={item.key} type="button" $active={currentMenu === item.key} $isMobile={isMobile} onClick={() => history.push(item.path)}>
          <IconWrap $isMobile={isMobile}>{item.icon}</IconWrap>
          <span>{item.label}</span>
        </MenuButton>
      ))}
    </Wrap>
  );
}
